// extracted by mini-css-extract-plugin
export var container = "module-card-module--container--2iz4J";
export var btnContainer = "module-card-module--btnContainer--29uby";
export var btnTitleFont = "module-card-module--btnTitleFont--3et6p";
export var cardTitleFont = "module-card-module--cardTitleFont--kBf7s";